import React, { useEffect, useState } from "react";
import "../../css_files/Master/SearchCustomerPricingMaster.css";
import CloseForm from "./CloseForm";
import axios from "axios";
import { toast } from "react-toastify";
import getCookie from "../../api";
import axiosInstance from "../../api";
import LoadingScreen from "../Homepage/LoadingScreen";

function SearchCustomerPricingMaster({
  setshowsearchform,
  setsearchedtabledata,
  setReload,
  reload,
}) {
  const [searchData, setSearchData] = useState({
    Id: "",
    Code: "",
    Rate: "",
  });
  const [loading, setloading] = useState(false);

  function handleSearch(e) {
    e.preventDefault();
    setloading(true);
    const url = `${
      process.env.REACT_APP_API_URL
    }/api/v1/CustomerPricing/GetCustomerPricingByIdOrCodeOrPercentage?id=${
      searchData.Id || "0"
    }&code=${searchData.Code || "0"}&Percentage=${searchData.Rate || "0"}`;
    axiosInstance
      .get(url)
      .then((res) => {
        setsearchedtabledata(res.data);

        toast.success("Fetched", {
          position: "bottom-center",
          theme: "dark",
        });
        setloading(false);
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response.data.error, {
          position: "bottom-center",
          theme: "dark",
        });
        setloading(false);
      });
  }
  return (
    <form
      className="search-customer-pricing-master-form"
      onSubmit={handleSearch}
    >
      <h3>Search Customer Pricing Master by Entering at least One Field</h3>
      <blockquote>
        <label>Id</label>
        <input
          type="number"
          placeholder="Enter Customer Id"
          onChange={(e) => setSearchData({ ...searchData, Id: e.target.value })}
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 9);
          }}
          value={searchData.Id}
        />
      </blockquote>
      <blockquote>
        <label>Code</label>
        <input
          type="text"
          placeholder="Enter Customer Code"
          onChange={(e) =>
            setSearchData({ ...searchData, Code: e.target.value })
          }
          value={searchData.Code}
          onInput={(e) => {
            e.target.value = e.target.value.toUpperCase().slice(0, 1);
          }}
        />
      </blockquote>
      <blockquote>
        <label>Rate</label>
        <input
          type="text"
          placeholder="Enter Rate"
          onInput={(e) => {
            e.target.value = e.target.value
              .replace(/[^0-9.]/g, "")
              .replace(/^(\d{3,})\d/g, "$1")
              .replace(/(\..*?)\./g, "$1")
              .replace(/^(\d{0,3})(\.\d{0,2})?.*$/, "$1$2");

            if (parseFloat(e.target.value) > 100) {
              e.target.value = "100.00";
            }
          }}
          onChange={(e) =>
            setSearchData({ ...searchData, Rate: e.target.value })
          }
          value={searchData.Rate}
        />
      </blockquote>
      <button type="submit">Search</button>
      <CloseForm
        close={(x) => {
          setshowsearchform(x);
          setReload(!reload);
        }}
      />
      {loading && <LoadingScreen />}
    </form>
  );
}

export default SearchCustomerPricingMaster;
